// extracted by mini-css-extract-plugin
export default {"barContainer":"AttentionBar_barContainer__I4DRr","label":"AttentionBar_label__Bo-G+"};